import integration from './integration';
import lookup from './lookup';

const composers = { integration, lookup };

export default composers;
